import React from "react";
import { Formik, Field, Form } from "formik";
import l from "components/util/l";
import lodash from "lodash";
import RichText from "components/util/schema_form/fields/rich_text/RichText";
import RulesField from "components/presentation/chat/model/Model.sub.RulesField.view";
import SelectDescriptiveField from "components/util/helpers/SelectDescriptiveField";
import { Wizard } from "components/util/helpers/Wizard";

const ModelView = ({
  flow,
  models,
  nodes,
  collections,
  dataReqs,
  chatSettings,
  ruleMode,
  isAdmin,
  isDeveloper,
  initialValues,
  refetchQueries,
  onSubmit,
}) => (

  <div className="px-3 px-md-4 py-5">

    <h2 className="mb-3">{l("Configurar IA%PA171")}</h2>

    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}>
      {({ values, setFieldValue }) =>
        <Form>
          {/* Prompt */}
          <div>
            <label className="dropdown-header px-0 pt-3 text-dark">{l("Instrucciones%PA126")}</label>
            <div class="form-group mb-4 position-relative">

              <RichText
                id="prompt"
                name="chat_settings.prompt"
                placeholder={l("Ej. Actua como un agente que ayuda a clienes%PA166")}
                value={lodash.get(values, "chat_settings.prompt")}
                values={values}
                setFieldValue={setFieldValue}
                dataReqs={dataReqs}
                singleLine={false}
                showStyles={true}
                rows={9}
                variableOptions={{
                  dataReqs: dataReqs,
                  showConstants: true,
                  selectorFilters: [{
                    type: "SOURCE",
                    value: "none"
                  }]
                }}
              />

              <Wizard
                flow={flow}
                mainProcessName={"GENERATE_PROMPT"}
                params={{
                  flow_id: flow?.id,
                  prompt: chatSettings?.prompt || "",
                  has_prompt: !!chatSettings?.prompt,
                }}
                onCompleted={refetchQueries}
                buttonStyle={{ padding: "0.4rem 0.65rem", fontSize: "0.85rem", marginTop: "-2.3rem" }}
                buttonClassName="float-right"
              />

            </div>
          </div>

          
          {/* Rules */}
          <div className="mt-5">

            <label className="dropdown-header px-0 pb-2 text-dark">{l("Base de conocimiento%PA173")}</label>
          
            {/* Temp hide
            <div className="mb-3">
              <div className="tabs d-flex mb-4">

                <button
                  type="button"
                  className={"dropdown-header py-2 " + (ruleMode == "DATA" ? "active" : "")}
                  style={{ fontSize: "0.85em" }}
                  onClick={() => setRuleMode("DATA")}
                >
                  {l("Datos%GA096")}
                </button>

                <button
                  type="button"
                  className={"dropdown-header py-2 " + (ruleMode == "EXECUTION" ? "active" : "")}
                  style={{ fontSize: "0.85em" }}
                  onClick={() => setRuleMode("EXECUTION")}
                >
                  {l("Procesos%GA095")}
                </button>
              </div>
            </div>
             */}

            <RulesField
              flow={flow}
              name={"flow_chat_rules"}
              values={values}
              ruleMode={ruleMode}
              isDeveloper={isDeveloper}
              setFieldValue={setFieldValue}
              nodes={nodes}
              collections={collections}
              dataReqs={dataReqs}
            />

          </div>

          <hr className="mt-5 mb-5" />

          {/* Chat */}
          <div>

            <label className="dropdown-header px-0 pb-4 text-dark">{l("Chat%PA113")}</label>

            <div class="form-group mb-3">
              <div class="custom-control custom-checkbox">
                <Field type="checkbox" name="chat_settings.overwrite_initial_message" id="overwrite_initial_message"
                  class="custom-control-input" />
                <label class="custom-control-label" for="overwrite_initial_message">
                  {l("Ajustar mensaje inicial%PA133")}
                </label>
              </div>
            </div>

            {
              values.chat_settings?.overwrite_initial_message &&
              <div className="mb-3 position-relative">
                <RichText
                  id="initial_message"
                  name="chat_settings.initial_message"
                  value={lodash.get(values, "chat_settings.initial_message")}
                  values={values}
                  setFieldValue={setFieldValue}
                  dataReqs={dataReqs}
                  singleLine={false}
                  rows={5}
                  showStyles={true}
                  variableOptions={{
                    dataReqs: dataReqs,
                    showConstants: true,
                    selectorFilters: [{
                      type: "SOURCE",
                      value: "none"
                    }]
                  }}
                />
              </div>
            }

            <div class="form-group mb-3">
              <div class="custom-control custom-checkbox">
                <Field type="checkbox" name="chat_settings.hide_suggestions" id="hide_suggestions"
                  class="custom-control-input" />
                <label class="custom-control-label" for="hide_suggestions">
                  {l("Ocultar sugerencias%PA101")}
                </label>
              </div>
            </div>

            <div class="form-group mb-3">
              <div class="custom-control custom-checkbox">
                <Field type="checkbox" name="chat_settings.keep_chat" id="keep_chat"
                  class="custom-control-input" />
                <label class="custom-control-label" for="keep_chat">
                  {l("Conservar conversación al iniciar%PA181")}
                </label>
              </div>
            </div>

            <div class="form-group mb-3">
              <div class="custom-control custom-checkbox">
                <Field type="checkbox" name="chat_settings.run_on_start" id="run_on_start"
                  class="custom-control-input" />
                <label class="custom-control-label" for="run_on_start">
                  {l("Ejecutar proceso al iniciar%PA134")}
                </label>
              </div>
            </div>

            {
              values.chat_settings?.run_on_start && <>
                <div class="form-group mb-5">
                  <select
                    class="form-control"
                    value={values.chat_settings?.initial_node_id || ''}
                    onChange={e => {
                      setFieldValue("chat_settings.initial_node_id", e.target.value);
                    }}
                  >
                    <option value="">{l("Selecciona un proceso%PA135")}</option>
                    {nodes.map(node =>
                      <option
                        key={node.id}
                        value={node.id}
                      >
                        {node.rootName}
                      </option>
                    )}
                  </select>
                </div>
              </>
            }

          </div>

          {/* Model */}
          {isAdmin &&
            <div className="mt-6">
              <label className="dropdown-header px-0 pb-3 text-dark">{l("Modelo base%PA152")}</label>
              <div class="form-group mb-4">
                <SelectDescriptiveField
                  name="chat_settings.model.name"
                  value={values.chat_settings?.model?.name || ''}
                  onChange={(e) => {
                    const selectedModel = models.flatMap(model => model.models).find(subModel => subModel.name === e.target.value);
                    setFieldValue("chat_settings.model", selectedModel);
                  }}
                  options={
                    models.map(model => ({
                      label: model.name,
                      options: model.models.map(subModel => ({
                        label: subModel.public_name,
                        value: subModel.name,
                        description: subModel.description || "",
                      }))
                    }))
                  }
                  grouped={true}
                  placeholder={"Seleccionar modelo"}
                  className="form-control"
                />
              </div>
            </div>
          }

          <button type="submit" class="btn btn-primary font-weight-bold w-100 mt-4">
            {l("Guardar%GA023")}
          </button>

        </Form>
      }
    </Formik>

  </div>
);

export default ModelView;
